import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TagTheme } from '@fcom/ui-components';
import { Category } from '@fcom/dapi/api/models/category';
import { ServiceCatalogService } from '@fcom/dapi/interfaces/services.interface';
import { getIconForServiceCategory } from '@fcom/dapi/utils/service-category-utils';

import { hasProductInfoModal } from '../../../utils/bundles.utils';

const CONSTITUENT_DETAILS_LINK_KEY: Partial<Record<Category, string>> = {
  [Category.MEAL]: 'ancillaries.seatMeal.detailsLinkTitle',
  [Category.PRIORITY]: 'ancillaries.seatPriority.detailsLinkTitle',
  [Category.CABIN_BAGGAGE]: 'ancillaries.seatCabinBaggage.detailsLinkTitle',
  [Category.LOUNGE]: 'ancillaries.lounge.detailsLinkTitle',
};

@Component({
  selector: 'fin-bundle-service-card',
  templateUrl: './bundle-service-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    class: 'flex flex--nowrap flex-1 flex--basis0 ps-medium rounded-large dashed-border-secondary',
    '[class.dashed-box]': '!inCart()',
    '[class.surface-secondary]': 'inCart()',
  },
})
export class BundleServiceCardComponent {
  readonly service = input.required<ServiceCatalogService>();
  readonly inCart = input(false);

  readonly TagTheme = TagTheme;

  modalOpen = false;

  readonly icon = computed(() => getIconForServiceCategory(this.service().category));
  readonly hasModal = computed(() => hasProductInfoModal(this.service().category));
  readonly detailsLinkKey = computed(() => {
    const { category } = this.service();
    return CONSTITUENT_DETAILS_LINK_KEY[category] ?? `ancillaries.${category}.detailsLinkTitle`;
  });
}
